import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { SystemStatusService } from './system-status.service';

export function maintenanceAppInitializerFactory(injector: Injector): () => Promise<void> {
  return () => {
    const status = injector.get(SystemStatusService);
    const router = injector.get(Router);
    return (async () => {
      await status.loadInitial();
      if (status.isMaintenance()) {
        await router.navigateByUrl('/maintenance');
      }
    })();
  };
}
